import { useEffect } from 'react';

const RECAPTCHA_ENABLED = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true';
const RECAPTCHA_V3_SITE_KEY = process.env.REACT_APP_RECAPTCHAV3_APIKEY;

const RecaptchaLoader = () => {
  useEffect(() => {
    if (RECAPTCHA_ENABLED) {
      //console.log('reCAPTCHA is enabled, loading script...');

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_V3_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.id = 'recaptcha-enterprise-script';

      document.body.appendChild(script);

      return () => {
        const existingScript = document.getElementById(
          'recaptcha-enterprise-script'
        );
        if (existingScript) {
          document.body.removeChild(existingScript);
        }
      };
    }

    // Se RECAPTCHA_ENABLED for false, não faz nada.
  }, []);

  return null;
};

export default RecaptchaLoader;
